import serviceAxios from "./request";
// 获取tree结构的列表
export const regioncityTree = (data) => {
	return serviceAxios({
		url: `/app/region/cityTree`,
		method: "get",
		params:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 首页数据
export const homeIndex = (data) => {
	return serviceAxios({
		url: `/app/home/index`,
		method: "get",
		params:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 文章详情
export const articledetail = (data) => {
	return serviceAxios({
		url: `/app/article/detail`,
		method: "get",
		params:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 分类列表
export const articlecategoryList = (data) => {
	return serviceAxios({
		url: `/app/article/categoryList`,
		method: "get",
		params:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 文章列表
export const articleList = (data) => {
	return serviceAxios({
		url: `/app/article/list`,
		method: "get",
		params:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 获取课程分类列表
export const coursecategoryList = (data) => {
	return serviceAxios({
		url: `/app/course/categoryList`,
		method: "get",
		params:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 查询课程列表
export const courselist = (data) => {
	return serviceAxios({
		url: `/app/course/list`,
		method: "get",
		params:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 查询课程详情
export const coursedetail = (data) => {
	return serviceAxios({
		url: `/app/course/detail`,
		method: "get",
		params:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 查询证书列表-公共
export const memberCertificateSearch = (data) => {
	return serviceAxios({
		url: `/app/memberCertificate/search`,
		method: "get",
		params:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 查询分类列表 下载文件
export const downloadcategoryList = (data) => {
	return serviceAxios({
		url: `/app/download/categoryList`,
		method: "get",
		params:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 查询下载文件列表
export const downloadlist = (data) => {
	return serviceAxios({
		url: `/app/download/list`,
		method: "get",
		params:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 获取验证码
export const authMemberregCaptcha = (data) => {
	return serviceAxios({
		url: `/app/authMember/regCaptcha`,
		method: "get",
		params:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 搜索企业信息
export const companysearchCompany = (data) => {
	return serviceAxios({
		url: `/app/company/searchCompany`,
		method: "get",
		params:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};



// 手机号密码登录  学员
export const authMemberloginByPassword = (data) => {
	return serviceAxios({
		url: `/app/authMember/loginByPassword`,
		method: "post",
		data:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 验证码 登录  学员
export const authMemberloginByPasswordQY = (data) => {
	return serviceAxios({
		url: `/app/authMember/loginByCode`,
		method: "post",
		data:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 获取个人信息  学员
export const authMemberInfo = (data) => {
	return serviceAxios({
		url: `/app/authMember/info`,
		method: "get",
		params:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};


// 手机号密码登录  企业
export const authCompanyloginByPassword = (data) => {
	return serviceAxios({
		url: `/app/authCompany/loginByPassword`,
		method: "post",
		data:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 验证码 登录  企业
export const authCompanyloginByPasswordQY = (data) => {
	return serviceAxios({
		url: `/app/authCompany/loginByCode`,
		method: "post",
		data:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 获取企业信息  企业
export const authCompanyInfo = (data) => {
	return serviceAxios({
		url: `/app/authCompany/info`,
		method: "get",
		params:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};



// 帐号注册 普通
export const authMemberregister = (data) => {
	return serviceAxios({
		url: `/app/authMember/register`,
		// url: `/app/home/testRegister`,
		method: "post",
		data:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 帐号注册 企业
export const authCompanyregister = (data) => {
	return serviceAxios({
		url: `/app/authCompany/register`,
		method: "post",
		data:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};


// 查询用户消息列表 普通
export const messagememberMessageList = (data) => {
	return serviceAxios({
		url: `/app/message/memberMessageList`,
		method: "get",
		params:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 查询用户消息列表 普通 阅读
export const messagememberRead = (data) => {
	return serviceAxios({
		url: `/app/message/memberRead`,
		method: "get",
		params:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 查询用户消息列表 普通 全部已读
export const messagememberReadAll = (data) => {
	return serviceAxios({
		url: `/app/message/memberReadAll`,
		method: "get",
		params:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 查询用户消息列表 普通 全部删除
export const messagememberDeleteAll = (data) => {
	return serviceAxios({
		url: `/app/message/memberDeleteAll`,
		method: "get",
		params:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 查询企业消息列表 企业
export const messagecompanyMessageList = (data) => {
	return serviceAxios({
		url: `/app/message/companyMessageList`,
		method: "get",
		params:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 查询企业消息列表 企业 阅读
export const messagecompanyRead = (data) => {
	return serviceAxios({
		url: `/app/message/companyRead`,
		method: "get",
		params:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 查询企业消息列表 企业 全部已读
export const messagecompanyReadAll = (data) => {
	return serviceAxios({
		url: `/app/message/companyReadAll`,
		method: "get",
		params:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 查询企业消息列表 企业 全部删除
export const messagecompanyDeleteAll = (data) => {
	return serviceAxios({
		url: `/app/message/companyDeleteAll`,
		method: "get",
		params:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};


// 用户页面 ************普通用户
// 个人信息更新 
export const authMemberprofile = (data) => {
	return serviceAxios({
		url: `/app/authMember/profile`,
		method: "post",
		data:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 个人信息更新 企业
export const authCompanyprofilee = (data) => {
	return serviceAxios({
		url: `/app/authCompany/profile`,
		method: "post",
		data:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};

// 查询我的证书列表
export const memberCertificateList = (data) => {
	return serviceAxios({
		url: `/app/memberCertificate/list`,
		method: "get",
		params:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 查询开票信息列表 普通
export const memberInvoiceList = (data) => {
	return serviceAxios({
		url: `/app/memberInvoice/list`,
		method: "get",
		params:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 查询开票信息列表 企业
export const memberInvoiceListQY = (data) => {
	return serviceAxios({
		url: `/app/company/invoice/list`,
		method: "get",
		params:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 添加开票信息 普通
export const memberInvoiceadd = (data) => {
	return serviceAxios({
		url: `/app/memberInvoice/add`,
		method: "post",
		data:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 添加开票信息 企业
export const memberInvoiceaddQY = (data) => {
	return serviceAxios({
		url: `/app/company/invoice/add`,
		method: "post",
		data:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 查询开票信息详情 普通
export const memberInvoicedetail = (data) => {
	return serviceAxios({
		url: `/app/memberInvoice/detail`,
		method: "get",
		params:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 查询开票信息详情 企业
export const memberInvoicedetailQY = (data) => {
	return serviceAxios({
		url: `/app/company/invoice/detail`,
		method: "get",
		params:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 更新开票信息 普通
export const memberInvoiceupdate = (data) => {
	return serviceAxios({
		url: `/app/memberInvoice/update`,
		method: "post",
		data:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 更新开票信息 企业
export const memberInvoiceupdateQY = (data) => {
	return serviceAxios({
		url: `/app/company/invoice/update`,
		method: "post",
		data:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 删除开票信息 普通
export const memberInvoicedelete = (data) => {
	return serviceAxios({
		url: `/app/memberInvoice/delete`,
		method: "get",
		params:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 删除开票信息 企业
export const memberInvoicedeleteQY = (data) => {
	return serviceAxios({
		url: `/app/company/invoice/delete`,
		method: "get",
		params:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 重置密码
export const authMemberrestPassword = (data) => {
	return serviceAxios({
		url: `/app/authMember/restPassword`,
		method: "post",
		data:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 重置密码 已登录 企业
export const authMemberrestPasswordQY = (data) => {
	return serviceAxios({
		url: `/app/authCompany/updatePassword`,
		method: "post",
		data:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 修改手机 普通
export const authMemberupdateMobile = (data) => {
	return serviceAxios({
		url: `/app/authMember/updateMobile`,
		method: "post",
		data:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 修改手机 企业
export const authMemberupdateMobileQY = (data) => {
	return serviceAxios({
		url: `/app/authCompany/updateMobile`,
		method: "post",
		data:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};




// 课程订单部分*****
// 创建订单 课程
export const courseOrdercreate = (data) => {
	return serviceAxios({
		url: `/app/courseOrder/create`,
		method: "post",
		data:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 订单详情 课程
export const courseOrderdetail = (data) => {
	return serviceAxios({
		url: `/app/courseOrder/detail`,
		method: "get",
		params:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 取消订单 课程
export const courseOrderCancel = (data) => {
	return serviceAxios({
		url: `/app/courseOrder/cancel`,
		method: "get",
		params:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 更新订单发票信息 课程
export const courseOrderUpdateOrderInvoice = (data) => {
	return serviceAxios({
		url: `/app/courseOrder/updateOrderInvoice`,
		method: "post",
		data:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 微信 PC扫码支付 课程 个人
export const wxPaypcScanQRPay = (data) => {
	return serviceAxios({
		url: `/app/wxPay/pcScanQRPay`,
		method: "get",
		params:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 微信 PC扫码支付 课程 企业
export const wxPaypcScanQRPayQY = (data) => {
	return serviceAxios({
		url: `/app/wxPay/pcBatchPay`,
		method: "get",
		params:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 测试用支付 课程
export const courseOrdertestPay = (data) => {
	return serviceAxios({
		url: `/app/courseOrder/testPay`,
		method: "get",
		params:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 测试用支付 课程 企业
export const courseOrdertestPayOrder = (data) => {
	return serviceAxios({
		url: `/app/company/courseOrder/testPayOrder`,
		method: "GET",
		params:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 订单列表 课程  会员
export const courseOrderlist = (data) => {
	return serviceAxios({
		url: `/app/courseOrder/list`,
		method: "get",
		params:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 订单列表 课程  企业
export const courseOrderlistQY = (data) => {
	return serviceAxios({
		url: `/app/company/courseOrder/orderList`,
		method: "get",
		params:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 1.获取课程的视频列表-根据订单ID 课程
export const courseVideolistByOrderId = (data) => {
	return serviceAxios({
		url: `/app/courseVideo/listByOrderId`,
		method: "get",
		params:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 2.获取课程的视频详情
export const courseVideodetail = (data) => {
	return serviceAxios({
		url: `/app/courseVideo/detail`,
		method: "get",
		params:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 3.获取课程的视频播放地址
export const courseVideogetPlayInfo = (data) => {
	return serviceAxios({
		url: `/app/courseVideo/getPlayInfo`,
		method: "get",
		params:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 4.写入观看进度
export const courseVideoaddLearningProgress = (data) => {
	return serviceAxios({
		url: `/app/courseVideo/addLearningProgress`,
		method: "post",
		data:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 5.获取观看进度
export const courseVideogetLearningProgress = (data) => {
	return serviceAxios({
		url: `/app/courseVideo/getLearningProgress`,
		method: "get",
		params:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 1.视频课程-创建模拟考试
export const courseVideoExamCreate = (data) => {
	return serviceAxios({
		url: `/app/courseVideoExam/create`,
		method: "get",
		params:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};

// 2.视频课程-模拟考试详情
export const courseVideoExamdetail = (data) => {
	return serviceAxios({
		url: `/app/courseVideoExam/detail`,
		method: "get",
		params:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 3.视频课程-模拟考试交卷
export const courseVideoExamsubmit = (data) => {
	return serviceAxios({
		url: `/app/courseVideoExam/submit`,
		method: "post",
		data:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};


// 1.视频课程-创建考试 
export const courseOrderExamcreate = (data) => {
	return serviceAxios({
		url: `/app/courseOrderExam/create`,
		method: "get",
		params:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 2.考卷详情 正式考试
export const courseOrderExamDetail = (data) => {
	return serviceAxios({
		url: `/app/courseOrderExam/detail`,
		method: "get",
		params:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 3.提交考卷答题记录 正式考试
export const courseOrderExamsubmitExamRecord = (data) => {
	return serviceAxios({
		url: `/app/courseOrderExam/submitExamRecord`,
		method: "post",
		data:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 4.考试交卷  正式考试
export const courseOrderExamsubmit = (data) => {
	return serviceAxios({
		url: `/app/courseOrderExam/submit`,
		method: "post",
		data:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};




// 查询申请发票列表 会员
export const memberInvoiceorderInvoiceList = (data) => {
	return serviceAxios({
		url: `/app/memberInvoice/orderInvoiceList`,
		method: "get",
		params:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 查询申请发票详情 会员
export const memberInvoiceorderInvoiceDetail = (data) => {
	return serviceAxios({
		url: `/app/memberInvoice/orderInvoiceDetail`,
		method: "get",
		params:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};

// 查询申请发票列表 企业
export const memberInvoiceorderInvoiceListC = (data) => {
	return serviceAxios({
		url: `/app/company/invoice/orderInvoiceList`,
		method: "get",
		params:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 查询申请发票详情 企业
export const memberInvoiceorderInvoiceDetailC = (data) => {
	return serviceAxios({
		url: `/app/company/invoice/orderInvoiceDetail`,
		method: "get",
		params:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};




// 1.获取企业员工列表 企业
export const membermemberList = (data) => {
	return serviceAxios({
		url: `/app/company/member/memberList`,
		method: "get",
		params:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 2.修改员工密码 企业
export const memberupdateMemberPassword = (data) => {
	return serviceAxios({
		url: `/app/company/member/updateMemberPassword`,
		method: "post",
		data:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 3.获取企业员工详情 企业
export const membermemberDetail = (data) => {
	return serviceAxios({
		url: `/app/company/member/memberDetail`,
		method: "get",
		params:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};



// 创建批量报名订单 企业
export const courseOrderorderCreate = (data) => {
	return serviceAxios({
		url: `/app/company/courseOrder/orderCreate`,
		method: "post",
		data:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 订单详情 企业
export const courseOrderorderDetail = (data) => {
	return serviceAxios({
		url: `/app/company/courseOrder/orderDetail`,
		method: "get",
		params:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 取消订单 企业
export const courseOrderorderorderCancel = (data) => {
	return serviceAxios({
		url: `/app/company/courseOrder/orderCancel`,
		method: "get",
		params:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 更新订单发票信息 企业
export const courseOrderupdateOrderInvoice = (data) => {
	return serviceAxios({
		url: `/app/company/courseOrder/updateOrderInvoice`,
		method: "post",
		data:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};



// 获取企业报名过的课程 企业
export const courseappliedCourseList = (data) => {
	return serviceAxios({
		url: `/app/company/course/appliedCourseList`,
		method: "GET",
		params:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};

// 课程订单列表 企业
export const courseOrdercourseOrderList = (data) => {
	return serviceAxios({
		url: `/app/company/courseOrder/courseOrderList`,
		method: "GET",
		params:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};


// 取消报名订单 企业
export const courseOrdercourseOrderCancel = (data) => {
	return serviceAxios({
		url: `/app/company/courseOrder/courseOrderCancel`,
		method: "GET",
		params:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 批量缴费 未支付的订单 企业
export const courseOrdercourseOrderBatchPay = (data) => {
	return serviceAxios({
		url: `/app/company/courseOrder/courseOrderBatchPay`,
		method: "post",
		data:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 批量取消报名订单 企业
export const courseOrdercourseOrderBatchCancel = (data) => {
	return serviceAxios({
		url: `/app/company/courseOrder/courseOrderBatchCancel`,
		method: "post",
		data:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};



// 获取通知公告列表
export const noticeList = (data) => {
	return serviceAxios({
		url: `/app/notice/list`,
		method: "get",
		params:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 通知公告详细信息
export const noticeDetail = (data) => {
	return serviceAxios({
		url: `/app/notice/detail`,
		method: "get",
		params:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};

// 刷题
export const courseVideoExamallQuestion = (data) => {
	return serviceAxios({
		url: `/app/courseVideoExam/allQuestion`,
		method: "get",
		params:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 5.刷题记录
export const courseVideoExamquestionLog = (data) => {
	return serviceAxios({
		url: `/app/courseVideoExam/questionLog`,
		method: "get",
		params:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};
// 5.基本配置
export const configbase = (data) => {
	return serviceAxios({
		url: `/app/config/base`,
		method: "get",
		params:data,
		headers: {
			"Content-Type": "application/json"
		}
	});
};